import { render } from "./NewFinanceCard.vue?vue&type=template&id=bf9bab8a&scoped=true"
import script from "./NewFinanceCard.vue?vue&type=script&lang=js"
export * from "./NewFinanceCard.vue?vue&type=script&lang=js"

import "./NewFinanceCard.vue?vue&type=style&index=0&id=bf9bab8a&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf9bab8a"]])

export default __exports__